import GROUP_ALL from "./query.gql";

export interface GroupData {
  id: string;
  name: string;
  isPrivileged: boolean;
  allowRescueOperations: boolean;
}

export interface GroupAllData {
  groupFeed: {
    groups: GroupData[];
  };
}

export { GROUP_ALL };
